const e = {
  add: "Ajouter",
  cancel: "Annuler",
  clear: "Effacer",
  confirm: "Confirmer",
  delete: "Supprimer",
  redo: "Refaire",
  save: "Enregistrer",
  saveAs: "Enregistrer sous",
  undo: "Annuler"
}, o = {
  completed: "Completed",
  notCompleted: "Not completed",
  progressSteps: "Progress steps",
  stepOf: "Step {0} of {1}",
  percentComplete: "{0}{1} complete. Step {2} of {3}"
}, n = {
  cancel: "Annuler",
  confirm: "Confirmer",
  datePlaceholder: "Sélectionnez une date",
  datetimePlaceholder: "Sélectionnez la date et l'heure",
  endDatePlaceholder: "Date de fin",
  endDatetimePlaceholder: "Date et heure de fin",
  endMonthPlaceholder: "Mois de clôture",
  monthPlaceholder: "Sélectionnez le mois",
  now: "Maintenant",
  quarterPlaceholder: "Sélectionner un trimestre",
  selectDate: "Sélectionnez une date",
  selectTime: "Sélectionnez une heure",
  startDatePlaceholder: "Date de début",
  startDatetimePlaceholder: "Date et heure de début",
  startMonthPlaceholder: "Mois de début",
  today: "Aujourd'hui",
  weekPlaceholder: "Sélectionner la semaine",
  yearPlaceholder: "Sélectionnez l'année",
  chooseDateAriaLabel: "Choose Date",
  backToDateSelectionAriaLabel: "Back to Date Selection"
}, r = {
  placeholder: "Veuillez sélectionner"
}, t = {
  clear: "Effacer",
  negativeText: "Annuler",
  now: "Maintenant",
  placeholder: "Sélectionnez une heure",
  positiveText: "OK"
}, a = {
  placeholder: "Veuillez saisir"
}, l = {
  placeholder: "Veuillez saisir"
}, s = {
  placeholder: "Commencez à taper..."
}, c = {
  allRows: "Toutes les rangées",
  default: "Par défaut",
  deleteLayoutDescription: "Voulez-vous vraiment supprimer cette mise en page?",
  discardChanges: "Ignorer les modifications",
  discardLayoutChanges: "Ignorer les changements de mise en page",
  enterLayoutName: "Entrez le nom de la mise en page",
  enterRowNumber: "Entrez le nombre de lignes",
  fieldsSelected: "champs sélectionnés",
  freezeColumnDescription: "Figez la colonne à gauche",
  freezeUptoColumn: "Figer jusqu'à la colonne",
  frozen: "Gelé",
  layoutName: "Nom de la mise en page",
  manageColumns: "Gérer les colonnes",
  none: "Aucun",
  reorderRows: "Réorganiser les lignes",
  rowsSelected: "rangées sélectionnées",
  saveLayoutAs: "Enregistrer la mise en page sous",
  saveLayoutNew: "Enregistrer la nouvelle mise en page",
  search: "Rechercher",
  searchColumnsPlaceholder: "Rechercher des colonnes",
  searchFieldsPlaceholder: "Rechercher des champs",
  selectAll: "Sélectionner tout",
  setTableHeight: "Définir l'hauteur du tableau",
  unfreeze: "Dégeler",
  unsavedChanges: "Vous avez des modifications non enregistrées",
  unsavedChangesDescription: "Il pourrait y avoir une ou plusieurs modifications non enregistrées. Voulez-vous les enregistrer?"
}, i = {
  at: "à",
  colorAlreadyUsed: "Sélectionnez une autre couleur ou utiliser la couleur existante",
  colorNamePlaceholder: "Entrez le nom",
  customPlaceholder: "{{ Custom }}",
  nameAlreadyUsed: "Veuillez choisir un autre nom de couleur",
  noColorsAdded: "Vous n’avez pas de couleurs dans cette section."
}, u = {
  searchPlaceholder: "Rechercher"
}, d = {
  invalidPastedData: "Données collées non valides"
}, p = {
  of: "de",
  page: "Page",
  rowsPerPage: "Lignes par page"
}, h = {
  failedToUpload: "Échec du téléversement",
  retry: "Réessayer",
  clickToUpload: "Téléverser",
  orDragAndDrop: "Encadré et goutte à goutte",
  supportedFileTypes: "Type de fichier pris en charge :"
}, m = {
  global: e,
  Progress: o,
  DatePicker: n,
  Select: r,
  TimePicker: t,
  Input: a,
  InputNumber: l,
  InputTag: s,
  HLDataTable: c,
  ColorPicker: i,
  InputPhone: u,
  InputOtp: d,
  Pagination: p,
  Upload: h
};
export {
  i as ColorPicker,
  n as DatePicker,
  c as HLDataTable,
  a as Input,
  l as InputNumber,
  d as InputOtp,
  u as InputPhone,
  s as InputTag,
  p as Pagination,
  o as Progress,
  r as Select,
  t as TimePicker,
  h as Upload,
  m as default,
  e as global
};
